import PipelineActivityPage from '../../../components/admin/pipeline/PipelineActivityPage'
export default function PipelineActivity() { return <PipelineActivityPage /> }
